// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalFlag = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		width="1em"
		height="1em"
		viewBox="0 0 96 96"
		{...props}
	>
		<use fill="#FFF" fillRule="evenodd" xlinkHref="#GoalFlag_tsx__goal-sleep-two-a" />
		<path
			d="M67.814 24.031a1.5 1.5 0 0 1 .046.007l18.342 2.494a1.5 1.5 0 0 1 1.298 1.486v24.414a1.5 1.5 0 0 1-1.298 1.486l-17.806 2.423a1.493 1.493 0 0 1-1.153.157L50.386 58.79a1.493 1.493 0 0 1-1.153.157l-16.864 2.294a1.498 1.498 0 0 1-1.418-.606L18.467 44.595v44.503a1.5 1.5 0 1 1-3 0V19.01a7.202 7.202 0 0 1 1.5-14.243 7.202 7.202 0 0 1 1.5 14.243v16.847l12.516-16.081a1.5 1.5 0 0 1 1.448-.556l35.383 4.812Zm-1.68 29.59v-26.79l-15.011-2.042v30.874l15.01-2.042Zm3-.408 15.366-2.09V29.327l-15.367-2.09v25.975ZM48.122 56.07v-31.69l-14.456-1.966v35.623l14.456-1.967ZM30.667 25.065l-11.8 15.16 11.8 15.16v-30.32Zm-9.5-13.1c0-2.317-1.882-4.2-4.2-4.2a4.202 4.202 0 0 0-4.2 4.2c0 2.319 1.882 4.2 4.2 4.2 2.318 0 4.2-1.881 4.2-4.2Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default GoalFlag;
